import { onePagePpChange, packagePickerClickOnQuestion, platformizedPackagePickerAppLifecycleAppManagedRedirectsSrc17Evid2244, platformizedPackagePickerFaqClickLinkSrc17Evid2237, platformizedPackagePickerFooterClickSrc17Evid2240 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { EclipsePackagePickerSteps } from '../../types';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
const getBiFromStep = fromStep => {
  switch (fromStep) {
    case EclipsePackagePickerSteps.SELECT_CYCLE:
      return 'change_product_from_cycle_back';
    case EclipsePackagePickerSteps.CHECKOUT:
      return 'change_cycle_from_purchasePage_back';
  }
  return;
};
export const useInitLayoutBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields();
  const selectedCycleId = module.SDK.PackagePickerStore.useSelectedCycleId();
  const biCycle = BiUtils.getBiCycle(CycleUtils.convertCycleIdToCycle(selectedCycleId));
  const isLoading = isCommonBiEventsFieldsLoading;
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onBackButtonClick', _ref => {
      let {
        fromStep
      } = _ref;
      const additionalFields = {
        fromStep: getBiFromStep(fromStep),
        cycle: biCycle
      };
      biLogger == null || biLogger.report(
      // 17:3907
      onePagePpChange({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFaqItemClick', _ref2 => {
      let {
        action,
        questionKey
      } = _ref2;
      const additionalFields = {
        clickType: action === 'open' ? 'show' : 'hide',
        questionType: questionKey
      };
      biLogger == null || biLogger.report(
      // 17:3917
      packagePickerClickOnQuestion({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFaqLinkClick', _ref3 => {
      let {
        event
      } = _ref3;
      const additionalFields = {
        event
      };
      biLogger == null || biLogger.report(
      // 17:2237
      platformizedPackagePickerFaqClickLinkSrc17Evid2237({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onFooterLinkClick', _ref4 => {
      let {
        linkCode
      } = _ref4;
      const additionalFields = {
        link: linkCode
      };
      biLogger == null || biLogger.report(
      // 17:2240
      platformizedPackagePickerFooterClickSrc17Evid2240({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onRedirect', _ref5 => {
      let {
        fromStep,
        toStep,
        reason
      } = _ref5;
      const additionalFields = {
        fromStep: fromStep,
        toStep: toStep,
        reason
      };
      biLogger == null || biLogger.report(
      // 17:2244
      platformizedPackagePickerAppLifecycleAppManagedRedirectsSrc17Evid2244({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields, biCycle]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitLayoutBiEvents.js.map